export default __webpack_public_path__ + "static/media/google-play-download.022c8316.svg";